import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CueHistory, CueTagSeverity } from 'src/app/models/fincas/cue.model';
import { CueStatusPresenter } from '../../presenters/cue-status.presenter';

/** Shows the main CUE status using user-facing wording. */
@Component({
  selector: 'app-cue-main-status',
  templateUrl: './cue-main-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueMainStatusComponent {
  @Input()
  public statusCue: CueHistory | null = null;

  @Input()
  public showSpinner = false;

  public get currentStatusText(): string {
    return CueStatusPresenter.currentStatusText(this.statusCue);
  }

  public get statusDescription(): string {
    return CueStatusPresenter.statusDescription(this.statusCue);
  }

  public get statusIcon(): string {
    return CueStatusPresenter.statusIcon(this.statusCue);
  }

  public get statusLabel(): string {
    return CueStatusPresenter.statusLabel(this.statusCue?.estado);
  }

  public get statusSeverity(): CueTagSeverity {
    return CueStatusPresenter.statusSeverity(this.statusCue?.estado);
  }
}
